import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { selectGroups } from './groups.selectors';
import { needsLoading, LoadingStatus, GoAction, QueueAlertAction, AlertType } from '@app/core';
import { take, filter, map } from 'rxjs/operators';
import { LoadingGroupsAction, RemoveGroupByIdAction } from './groups.actions';
import { SelectGroupAction } from '../group-details/group-details.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var GroupFacadeService = /** @class */ (function () {
    function GroupFacadeService(store) {
        this.store = store;
        this.groups$ = of();
        this.loading$ = of();
        this.loaded$ = of();
        this.loadFailed$ = of();
        this.groupState$ = of();
    }
    GroupFacadeService.prototype.initializeGroup = function () {
        var _this = this;
        this.groupState$ = this.store.pipe(select(selectGroups));
        this.groupState$.pipe(take(1), filter(function (items) { return needsLoading(items); }))
            .subscribe(function () { return _this.store.dispatch(new LoadingGroupsAction()); });
        this.groups$ = this.groupState$.pipe(filter(function (items) { return !needsLoading(items); }), map(function (state) { return state.data; }));
        this.loading$ = this.groups$.pipe(map(function (groups) { return groups.status === LoadingStatus.LOADING; }));
        this.loaded$ = this.groups$.pipe(map(function (groups) { return groups.status === LoadingStatus.LOAD_COMPLETE; }));
        this.loadFailed$ = this.groups$.pipe(map(function (groups) { return groups.status === LoadingStatus.LOAD_FAILED; }));
    };
    GroupFacadeService.prototype.selectGroup = function (row) {
        this.store.dispatch(new SelectGroupAction(row));
    };
    GroupFacadeService.prototype.removeGroup = function (removedId) {
        this.store.dispatch(new RemoveGroupByIdAction(removedId));
    };
    GroupFacadeService.prototype.goToGroupDetail = function (row) {
        this.store.dispatch(new SelectGroupAction(row));
        this.store.dispatch(new GoAction(['/iam/groups', row.group_id]));
    };
    GroupFacadeService.prototype.goToEditGroup = function (row) {
        this.store.dispatch(new SelectGroupAction(row));
        this.store.dispatch(new GoAction(['/iam/groups', row.group_id, 'edit']));
    };
    GroupFacadeService.prototype.removeGroupSucceed = function (removeId) {
        this.store.dispatch(new RemoveGroupByIdAction(removeId));
        this.store.dispatch(new QueueAlertAction({ alertText: "Group delete succeed.", alertType: AlertType.SUCCESS }));
    };
    GroupFacadeService.prototype.removeGroupFailed = function () {
        this.store.dispatch(new QueueAlertAction({ alertText: "Group delete failed.", alertType: AlertType.ERROR }));
    };
    GroupFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function GroupFacadeService_Factory() { return new GroupFacadeService(i0.inject(i1.Store)); }, token: GroupFacadeService, providedIn: "root" });
    return GroupFacadeService;
}());
export { GroupFacadeService };



// WEBPACK FOOTER //
// ./src/app/access-management/state/groups/group.facade.ts.pre-build-optimizer.js